const TOKEN_KEY = 'authToken';

/**
 * Read the persisted auth token (if any).
 */
export const getToken = () => {
  try {
    return localStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
};

/**
 * Persist the auth token. Passing a falsy value clears it.
 */
export const setToken = (token) => {
  try {
    if (token) {
      localStorage.setItem(TOKEN_KEY, token);
    } else {
      localStorage.removeItem(TOKEN_KEY);
    }
  } catch {
    // Swallow storage errors; calling code should handle auth flow without crashing.
  }
};

/**
 * Remove the auth token explicitly.
 */
export const clearToken = () => {
  setToken(null);
};

/**
 * Convenience helper that returns an Authorization header map when a token exists.
 */
export const getAuthHeader = () => {
  const token = getToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};

/**
 * Extract user ID from the JWT token.
 * Returns null if no token or invalid token.
 */
export const getUserIdFromToken = () => {
  try {
    const token = getToken();
    if (!token) return null;

    // Decode JWT token (format: header.payload.signature)
    const base64Url = token.split('.')[1];
    if (!base64Url) return null;

    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );

    const payload = JSON.parse(jsonPayload);
    return payload.sub || payload.user_id || payload.id || null;
  } catch (error) {
    console.error('Error extracting user ID from token:', error);
    return null;
  }
};

export default {
  TOKEN_KEY,
  getToken,
  setToken,
  clearToken,
  getAuthHeader,
  getUserIdFromToken,
};
